import { Box, Typography, Button, Tooltip } from "@mui/material";
import styled from "styled-components";

export const Wrapper = styled(Box)`
  ${({ theme }) => `
    position: relative;
    background: #F9F9F9;
    // width: 100vw;
    // height: 100vh;
    // max-width: 100vw;
    // max-height: 100vh;
    display: flex;
    justify-content: space-between;
   
    overflow: hidden;

    ${theme.breakpoints.down("lg")} {
      // padding: 0 7.5% 0 7.5%; 
    }
  `}
`;

export const PasswordToolTip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className, tooltip: "tooltip" }}
    {...props}
  />
))`
  ${({ theme }) => `
    & .tooltip {
      margin-top: 1%;
      background: #e0eef0;
      color: ${theme.palette.secondary.main};

      & > ul {
        ${theme.mixins.makeResponsive({ theme, fontSize: 14 })};
        padding: 0 20px;
        li {
          margin: 3% 0;
        }
      }
    }
  `}
`;

export const LogoDiv = styled(Box)`
  ${({ theme }) => `
    margin : 1.5rem 0 ;
    cursor : pointer;
    width: 100px;
    height: 100px;

  `}
`;

export const Logo = styled.img`
  width: auto;
  width: 100%;
`;

export const DescriptionDiv = styled(Box)`
  ${({ theme }) => `
    
    width: 30%;
    min-width: 30%;
    margin-top: 10%;
    margin-right: auto;
    margin-left: auto;
  `}
`;

export const DescriptionHeader = styled(Typography)`
  ${({ theme }) => `
    color: ${theme.palette.dark.black};
    ${theme.mixins.makeResponsive({ theme, fontSize: 56, lineHeight: 66 })};
    font-weight: 700;
    font-family: 'Black Sans';
  `}
`;

export const DescriptionCaption = styled(Typography)`
  ${({ theme }) => `
    font-family: 'Black Sans';
    color: ${theme.palette.dark.main};
    ${theme.mixins.makeResponsive({ theme, fontSize: 18, lineHeight: 27 })};
    font-weight: 400;
    margin-top: 33px;
    ${theme.breakpoints.down("lg")} {
      margin-top: 20px;
    }
  `}
`;

export const IllustrationDiv = styled(Box)`
  ${({ theme }) => `
    overflow: hidden;
    margin-top: 5%;
    width: 350px;
    margin: 0 auto;
    img {
      max-width: 100%;
      max-height: 100%;
    }

    ${theme.breakpoints.down("lg")} {
      width: 350px;
    }
  `}
`;

export const Text = styled(Typography)`
  font-weight: 600;
  font-size: 26px;
  line-height: 138.83%;
  text-align: center;
  color: #444444;
`;

export const Illustration = styled.img``;

export const ShowPassword = styled(Button)`
  font-family: "Black Sans";

  position: absolute !important;
  top: 17%;
  right: 1%;
  transform: translateY(0%);
  color: #a8a8a8;
  line-height: 14px;
  span {
    font-size: 13.0577px;
    text-transform: capitalize;
  }

  @media only screen and (min-width: 1920px) {
    position: absolute;
    top: 50%;
    right: 1%;
    top: 130%;
  }
`;
